const amazonConnectAgentStates = {
  AFTER_CALL_WORK: "AfterCallWork",
  PENDING_BUSY: "PendingBusy",
  MISSED_CALL_AGENT: "MissedCallAgent",
  INIT: "Init",
  OFFLINE: "Offline",
  BUSY: "Busy",
  FAILED_CONNECT_AGENT: "FailedConnectAgent",
  AVAILABLE: "Available",
  CALLING_CUSTOMER: "CallingCustomer",
};

export default amazonConnectAgentStates;